export function getPaginatedList(list: any[], page: number, rowSize: number): any[] {
  const startIndex = 0 + ((page - 1) * rowSize);
  const endIndex = startIndex + rowSize;
  return list ? list.slice(startIndex, endIndex) : [];
}


// WEBPACK FOOTER //
// ./src/util/pagination.tsx